<!--  -->
<template>
  <div>
    <div class="optionbox">
      <div class="optiontext">选择平台：</div>
      <el-select
        v-model="obj.platformvalue"
        placeholder="请选择"
        @change="chooseplate"
      >
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </div>
    <div class="optionbox">
      <div class="optiontext">选择书籍：</div>
      <el-tag
        v-if="obj.bookname!=''"
        style="margin-right:10px"
      >{{ obj.bookname }}</el-tag>
      <el-button
        type="primary"
        size="mini"
        :disabled="obj.platformvalue==null"
        @click="choosebookid"
      >选择书籍</el-button>
    </div>
    <div
      v-if="[1,2,3,4,6,8,9,10,11,12,31,34,23].includes(obj.platformvalue)"
      class="optionbox"
    >
      <div class="optiontext">选择章节：</div>
      <el-tag
        v-if="obj.chaptername!=''"
        style="margin-right:10px"
      >{{ obj.chaptername }}</el-tag>
      <el-button
        type="primary"
        size="mini"
        :disabled="obj.bookid==null"
        @click="chapterclick"
      >选择章节</el-button>
    </div>
    <div
      v-if="[1,5,6,7].includes(obj.platformvalue)"
      class="optionbox"
    >
      <div class="optiontext">推广链接类型：</div>
      <el-radio-group v-model="obj.radio">
        <el-radio :label="0">外派</el-radio>
        <el-radio :label="1">内推</el-radio>
      </el-radio-group>
    </div>
    <div>
      <!-- 阅文 -->
      <yuwenlink
        v-if="obj.platformvalue == 2"
        ref="yuwenview"
        :obj="obj"
        @close="close"
      />
      <!-- 阳光 -->
      <sunlink
        v-if="obj.platformvalue == 1"
        ref="sunview"
        :obj="obj"
        @close="close"
      />
      <!-- 追书云 -->
      <zsylink
        v-if="obj.platformvalue == 9"
        ref="zsyview"
        :obj="obj"
        @close="close"
      />

      <!-- 文鼎 -->
      <wdlink
        v-if="obj.platformvalue == 3"
        ref="wdview"
        :obj="obj"
        @close="close"
      />
      <!-- 七悦 -->
      <qylink
        v-if="obj.platformvalue == 6"
        ref="qyview"
        :obj="obj"
        @close="close"
      />

      <!-- 看书网 -->
      <kswlink
        v-if="obj.platformvalue == 10"
        ref="kswview"
        :obj="obj"
        @close="close"
      />

      <!-- 掌读 -->
      <zdlink
        v-if="obj.platformvalue == 11"
        ref="zdview"
        :obj="obj"
        @close="close"
      />
      <!-- 万读 -->
      <wanduwanglink
        v-if="obj.platformvalue == 4"
        ref="zdview"
        :obj="obj"
        @close="close"
      />

      <!-- 国风 -->
      <gflink
        v-if="obj.platformvalue == 8"
        ref="wdview"
        :obj="obj"
        @close="close"
      />
      <!-- 中文在线 -->
      <zwlink
        v-if="obj.platformvalue == 12"
        ref="zwview"
        :obj="obj"
        @close="close"
      />
      <!-- 常读 -->
      <cdlink
        v-if="obj.platformvalue == 13"
        ref="cdview"
        :obj="obj"
        @close="close"
      />

      <!-- 蘑菇 -->
      <mogu
        v-if="obj.platformvalue == 31"
        ref="mgview"
        :obj="obj"
        @close="close"
      />

      <!-- 野象 -->
      <yexiang
        v-if="obj.platformvalue == 34"
        ref="mgview"
        :obj="obj"
        @close="close"
      />

      <!-- 朵格 -->
      <duogelink
        v-if="obj.platformvalue == 23"
        ref="mgview"
        :obj="obj"
        @close="close"
      />
    </div>

    <el-dialog
      title="选择书籍"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="dialogVisibler"
      :destroy-on-close="true"
    >
      <bookdialog
        ref="chooseviewr"
        @callback="callback"
      />
    </el-dialog>
    <el-dialog
      title="选择章节"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="chapterdialogVisibler"
      :destroy-on-close="true"
    >
      <chapterdialog
        ref="chapterviewr"
        @chaptercallback="chaptercallback"
      />
    </el-dialog>
  </div>
</template>

<script>
import { strategyPlatformtwo } from '@/api/sourceMaterial.js'
import bookdialog from './bookdialog.vue'
import chapterdialog from './chapterdialog.vue'
import yuwenlink from './yuwenlink.vue'
import sunlink from './sunlink.vue'
import zsylink from './zsylink.vue'
import wdlink from './wdlink.vue'
import qylink from './qylink.vue'
import kswlink from './kswlink.vue'
import zdlink from './zdlink.vue'
import wanduwanglink from './wanduwanglink.vue'
import gflink from './gflink.vue'
import cdlink from './cdlink.vue'
import zwlink from './zwlink.vue'
import mogu from './mogu.vue'
import yexiang from './yexiang.vue'
import duogelink from './duogelink.vue'
export default {
  components: { bookdialog, chapterdialog, yuwenlink, sunlink, zsylink, wdlink, qylink, kswlink, zdlink, wanduwanglink, gflink, cdlink, zwlink, mogu, yexiang, duogelink },
  data() {
    return {
      obj: {
        platformvalue: null, // 平台id
        bookname: '', // 书籍名称
        bookid: null, // 书籍id
        bookids: null, // 书籍主键id
        chaptername: '', // 章节名称
        chapterid: null, // 章节id
        chapteridx: null, // 章节号
        radio: 0, // 推广链接类型
        num: null
      },
      dialogVisibler: false,
      chapterdialogVisibler: false,

      options: [] // 平台数组
    }
  },
  created() {
    this.getPlatform()
  },
  mounted() {},
  methods: {
    // 获取平台
    async getPlatform() {
      const data = await strategyPlatformtwo()
      this.options = data.data.list
    },
    chooseplate(val) {
      this.obj.bookname = ''
      this.obj.bookid = null
      this.obj.bookids = null
      this.obj.chaptername = ''
      this.obj.chapterid = null
      this.obj.chapteridx = null
      this.obj.num = null
    },
    choosebookid() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.chooseviewr.send(this.obj.platformvalue)
      })
    },
    callback(val) {
      console.log('val', val)
      this.dialogVisibler = false
      this.obj.bookname = val.book_title
      this.obj.bookid = val.book_id
      this.obj.bookids = val.id
      // 清空上次选择的章节
      this.obj.chaptername = ''
      this.obj.chapterid = null
      this.obj.chapteridx = null
      this.obj.num = null
    },

    chaptercallback(val) {
      console.log('val1', val)
      this.chapterdialogVisibler = false
      this.obj.chaptername = val.chapter_name
      this.obj.chapterid = val.chapter_id
      this.obj.chapteridx = val.chapter_idx
      this.obj.num = val.num
    },
    chapterclick() {
      this.chapterdialogVisibler = true
      this.$nextTick(() => {
        this.$refs.chapterviewr.send(this.obj.platformvalue, this.obj.bookids)
      })
    },
    close() {
      this.$emit('updata')
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.optionbox {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.optiontext {
  width: 100px;
  text-align: right;
}
</style>
